import { Icon } from '@payfit/growth-platform-brand-system-v2/components/Picto/Icon';
import {
  Tag,
  TagBlockProps,
} from '@payfit/growth-platform-brand-system-v2/components/Tag';
import {
  fontCaption,
  fontMegaBodyMedium,
} from '@payfit/growth-platform-brand-system-v2/styles/typographyNew';
import { SiteLocale } from 'apps/website/types/dato';
import { classNames } from 'libs/growth-platform-brand-system-v2/src/utils/style';
import React from 'react';
import { useQueryParam } from '../scripts/hooks/useQueryParam';
import { MIN_VALUE_NUMBER_EMPLOYEE } from '../SettingsPanel/InputNbEmployee';
import { shortcode } from 'apps/website/src/utils/Shortcode';

type HeaderProps = {
  title: string;
  text: string;
  offerTitle: string;
  locale: SiteLocale;
  promoTag: TagBlockProps;
};

const Header = ({ title, text, offerTitle, locale, promoTag }: HeaderProps) => {
  const [_nbEmployee] = useQueryParam(
    'nbEmployee',
    MIN_VALUE_NUMBER_EMPLOYEE.toString(),
  );
  // Ensure nbEmployee is a number with a fallback to the minimum value
  const nbEmployee = _nbEmployee
    ? parseInt(_nbEmployee as string, 10)
    : MIN_VALUE_NUMBER_EMPLOYEE;

  return (
    <div
      className={classNames(
        'PriceBreakdown_Header',
        'flex flex-col gap-x-16 gap-y-8',
      )}
    >
      <div className={classNames(fontMegaBodyMedium)}>{title}</div>
      <div
        className={classNames(fontCaption, 'p_bold')}
        dangerouslySetInnerHTML={{
          __html: shortcode(text, locale)
            .pricingPage.applySingularPlural({ count: nbEmployee })
            .applyNbEmployee({ nbEmployee: nbEmployee })
            .applyOfferTitle({ offerTitle: offerTitle })
            .toString(),
        }}
      />
      {promoTag && (
        <div className="w-fit">
          <Tag color={promoTag.color}>
            <Icon
              className="h-[16px] w-[16px] p-0"
              twTextColor="text-inherit"
              name={'verified_stroke'}
            />
            {promoTag.title}
          </Tag>
        </div>
      )}
    </div>
  );
};

export default Header;
